import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgEmoji = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fill: "#ffffff",
		fillOpacity: 0,
		d: "M-1-1h16v16H-1z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M6.993.333A6.663 6.663 0 0 0 .333 7c0 3.68 2.98 6.667 6.66 6.667A6.67 6.67 0 0 0 13.667 7 6.67 6.67 0 0 0 6.993.333zm.007 12A5.332 5.332 0 0 1 1.667 7 5.332 5.332 0 0 1 7 1.667 5.332 5.332 0 0 1 12.333 7 5.332 5.332 0 0 1 7 12.333zm2.333-6c.554 0 1-.446 1-1 0-.553-.446-1-1-1-.553 0-1 .447-1 1 0 .554.447 1 1 1zm-4.666 0c.553 0 1-.446 1-1 0-.553-.447-1-1-1-.554 0-1 .447-1 1 0 .554.446 1 1 1zM7 10.667a3.664 3.664 0 0 0 3.407-2.334H3.593A3.664 3.664 0 0 0 7 10.667z"
	})] })
});
export default SvgEmoji;
